import FaqLayout from "@/components/feature/FaqLayout";

export default function RefundPage() {
  return (
    <FaqLayout
      breadcrumb="/ Billing & Payments"
      title="Where is my"
      accent="refund?"
    >
      <div className="space-y-6 text-[#1A1C1E]">
        <h2 className="text-2xl font-bold text-[#1A1C1E]">Refund Status and Processing Times</h2>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Refunds are processed automatically once approved. The time it takes for the funds to appear in your account depends on your original payment method and your bank's processing policies.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Typical Refund Timelines</h3>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563]">
          <li><strong>Credit/Debit Cards:</strong> 5 to 10 business days</li>
          <li><strong>PayPal:</strong> 3 to 5 business days</li>
          <li><strong>Bank Transfer:</strong> 7 to 14 business days</li>
          <li><strong>Apple Pay / Google Pay:</strong> 3 to 7 business days</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">How to Check Your Refund Status</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          You can view the status of any refund request in your account dashboard under <strong>Billing History</strong>. Refund statuses are labeled as:
        </p>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563] mt-3">
          <li><strong>Pending:</strong> Your request is being reviewed by our team.</li>
          <li><strong>Approved:</strong> The refund has been authorized and sent to your payment provider.</li>
          <li><strong>Processed:</strong> The funds have left our system and are in transit to your bank.</li>
          <li><strong>Completed:</strong> The refund has been credited to your account.</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">What If My Refund Is Delayed?</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If more than 14 business days have passed and you still have not received your refund, please contact your bank or card issuer first, as they may be holding the funds. If your bank confirms no pending refund, reach out to our support team with your order ID and refund reference number.
        </p>

        <div className="bg-[#F7F5F2] rounded-xl p-6 mt-8">
          <p className="text-sm font-semibold text-[#1A1C1E] mb-2">Refund not showing up?</p>
          <p className="text-sm text-[#6C7278]">
            Contact our billing team with your transaction ID and we will trace the refund for you within 24 hours.
          </p>
        </div>
      </div>
    </FaqLayout>
  );
}